import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";

const BlogCard = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_BLOGS;
        const cacheKey = "blogs";
        const cacheTimeKey = "blogsTimestamp";
        const cacheExpiry = 30 * 60 * 1000; // 30 minutes in milliseconds

        const cachedBlogs = localStorage.getItem(cacheKey);
        const cacheTimestamp = localStorage.getItem(cacheTimeKey);

        if (cachedBlogs && cacheTimestamp && (Date.now() - parseInt(cacheTimestamp, 10)) < cacheExpiry) {
            // ✅ Load from cache
            setBlogs(JSON.parse(cachedBlogs));
        } else {
            // ❌ Fetch from API
            axios.get(`${apiBaseUrl}${Url}`)
                .then(response => {
                    setBlogs(response.data);
                    localStorage.setItem(cacheKey, JSON.stringify(response.data));
                    localStorage.setItem(cacheTimeKey, Date.now().toString());
                })
                .catch(error => console.error("Error fetching API", error));
        }
    }, []);

    return (
        <div className="blog-area pb-100 pt-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 mx-auto">
                        <div className="site-heading text-center wow fadeInDown" data-wow-delay=".25s">
                            <span className="site-title-tagline">
                                <i className="far fa-passport"></i> সংবাদ ও ব্লগ
                            </span>
                            <h2 className="site-title">আমাদের সাম্প্রতিক সংবাদ ও ব্লগ</h2>
                        </div>
                    </div>
                </div>
                <div className="row g-4">
                    {blogs.map((blog, index) => (
                        <div className="col-md-6 col-lg-4" key={index}>
                            <Link className="text-decoration-none" to={`/blog/details/${blog?.slug}`}>
                                <div className="blog-item wow fadeInUp" data-wow-delay=".25s">
                                    <div className="blog-item-img">
                                        <img src={`${backendBaseUrl}${blog?.image}`} alt="thumb"/>
                                    </div>
                                    <div className="blog-item-info">
                                        <h5 className="blog-title fw-bold text-dark">{blog?.title}</h5>
                                        <p className="text-dark">{blog?.short_description}</p>
                                        <Link className="theme-btn text-decoration-none" to={`/blog/details/${blog?.slug}`}>
                                            Read More <i className="fas fa-circle-arrow-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BlogCard;
